var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.value)?_c('font-awesome-icon',{attrs:{"icon":['fal', 'check-square'],"size":_vm.props.size}}):_c('font-awesome-icon',{attrs:{"icon":['fal', 'square'],"size":_vm.props.size}})}
var staticRenderFns = []

export { render, staticRenderFns }